var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g(_vm._b({attrs:{"data-cy":_vm.dataCy ? _vm.dataCy : false},scopedSlots:_vm._u([{key:"message",fn:function({ message }){return [_vm._v(" "+_vm._s(_vm.$t(message))+" ")]}}])},'v-checkbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }